module.exports = __webpack_public_path__ + "a6e36040a9fcb2111379b511e796e640.png";